// TODO: use env variable for api url
export const AppConfig = {
  API_URL:
    process.env.REACT_APP_API_URL || "https://divhubinter.polri.go.id/api",
  // Cloudflare R2 public URL for large assets (>25MB)
  R2_PUBLIC_URL:
    process.env.REACT_APP_R2_PUBLIC_URL ||
    "https://pub-d521374924e7441194e6c30912fa4dbb.r2.dev/divhubinter",
};

/**
 * Large files that exceed Cloudflare Pages 25MB limit
 * These are served from R2 instead of the static build
 */
const LARGE_ASSETS: Record<string, string> = {
  "/gallery/btnclo/BTNCLO_2.jpg": "/gallery/btnclo/BTNCLO_2.jpg",
  "/organisasi-internasional/KOMPILASI PROFILE NEGARA JILID 1.pdf":
    "/organisasi-internasional/KOMPILASI PROFILE NEGARA JILID 1.pdf",
  "/organisasi-internasional/KOMPILASI PROFILE NEGARA JILID 2.pdf":
    "/organisasi-internasional/KOMPILASI PROFILE NEGARA JILID 2.pdf",
  "/organisasi-internasional/KOMPILASI PROFILE NEGARA JILID 3.pdf":
    "/organisasi-internasional/KOMPILASI PROFILE NEGARA JILID 3.pdf",
  "/organisasi-internasional/KOMPILASI PROFILE NEGARA JILID 4.pdf":
    "/organisasi-internasional/KOMPILASI PROFILE NEGARA JILID 4.pdf",
};

/**
 * Get the correct URL for an asset, using R2 for large files
 * @param localPath - The local path to the asset (e.g., "/gallery/btnclo/BTNCLO_2.jpg")
 * @returns The URL to use (either local or R2)
 */
export function getAssetUrl(localPath: string): string {
  const r2Path = LARGE_ASSETS[localPath];
  if (r2Path) {
    return `${AppConfig.R2_PUBLIC_URL}${r2Path}`;
  }
  return localPath;
}
